import React from "react";
import { motion } from "framer-motion";

export default function EventStaffingHero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const mockupEntrance = {
    hidden: { opacity: 0, x: 50, scale: 0.95 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 0.85, ease: [0.25, 0.1, 0.25, 1], delay: 0.2 },
    },
  };

  return (
    <section className="es-hero-wrapper">
      <div className="container-fluid horizontal-padding">
        <div className="row align-items-stretch mx-0 py-lg-5 py-4 es-hero-row">
          {/* ── Left Column: Headline, Description & Stat ── */}
          <div className="col-12 col-lg-6 es-hero-left ps-0">
            <motion.div
              className="es-hero-left-content"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <div className="es-hero-text-block">
                <motion.h1 variants={itemVariants} className="es-hero-title">
                  <span className="es-gold-text">EventStaffing</span> &amp; Dealer
                  <span className="d-block">Booking Platform</span>
                  <span className="d-block">Development</span>
                </motion.h1>

                <motion.p variants={itemVariants} className="es-hero-desc">
                  A custom web-based platform that lets casino party dealers browse
                  invitations, request event assignments, and manage their
                  schedules, while giving GSH Casino Parties full control over
                  approvals.
                </motion.p>
              </div>

              <motion.div variants={itemVariants} className="es-hero-stat-wrap">
                <motion.div
                  className="es-stat-pill"
                  whileHover={{ scale: 1.03, y: -2 }}
                  transition={{ duration: 0.2 }}
                >
                  <span className="es-stat-number">500+</span>
                  <span className="es-stat-label">
                    Dealer &amp; Party Operations
                  </span>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>

          {/* ── Right Column: Hero Image with Floating & Ambient Glow Animations ── */}
          <div className="col-12 col-lg-6 es-hero-right pe-0">
            <motion.div
              className="es-device-frame-wrap"
              variants={mockupEntrance}
              initial="hidden"
              animate="visible"
            >
              {/* Pulsing ambient glow behind the mockup */}
              <motion.div
                className="es-frame-glow"
                animate={{
                  opacity: [0.5, 0.85, 0.5],
                  scale: [0.95, 1.05, 0.95],
                }}
                transition={{
                  duration: 4.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />

              {/* Mockup image with continuous gentle floating motion */}
              <motion.div
                className="es-hero-mockup-container"
                animate={{ y: [-6, 6, -6] }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.02 }}
              >
                <img
                  src="/images/event-staffing/event-staffing-hero-img.png"
                  alt="Event Staffing & Dealer Booking Platform Dashboard"
                  className="es-hero-img"
                  loading="eager"
                />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
